<div class="modal-header">
  <h5 class="modal-title" i18n="@@CreateDeliveryNoteHeader">Lieferschein generieren</h5>
  <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancelClick()"></button>
</div>

<div class="modal-body">
  <app-create-delivery-note (newEntityEvent)="newEntityEvent($event)" [transactions]="transactions" [userId]="userId" [customerId]="customerId" #createDeliveryNoteComponent></app-create-delivery-note>
</div>

<div class="modal-footer">
  <a class="btn btn-yellow me-2" id="cancel" data-bs-toggle="modal" role="button" data-bs-dismiss="modal" (click)="onCancelClick()" i18n="@@CancelButton">Abbrechen</a>
  <form [formGroup]="formService.form">
    <button type="button" id="create_deliverynote" class="btn btn-save me-2" 
            [disabled]="!formService.form.valid" 
            (click)="createDeliveryNoteComponent.onSubmit(formService.form.value, false)" 
            i18n="@@CreateDeliveryNoteButton">
            Erstellen
    </button>
    <button type="button" id="create_deliverynote_and_download" class="btn btn-save" 
            [disabled]="!formService.form.valid" 
            (click)="createDeliveryNoteComponent.onSubmit(formService.form.value, true)" 
            i18n="@@CreateDeliveryNoteButton">
            Erstellen und herunterladen
    </button>
  </form>
</div>
